// 关怀模式——主流程
const MainRoutes = Array.from({ length: 7 }, (_, i) => ({
  path: `care/index${i + 1}`,
  name: `careIndex${i + 1}`,
  component: () => import(`@/views/wxSettings/care/index${i + 1}.vue`)
}))



export default {
  path: '/wxSettings',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 关怀模式——主流程，开始
    ...MainRoutes,

  ],
};
